module.exports = __webpack_public_path__ + "img/logo.03a97b13.png";